export class CustomAccountIdMappingHelper {
  constructor({ form, setForm }) {
    this.form = form;
    this.setForm = setForm;
  }

  onKeyChange(val, warehouseId) {
    this.form.mapping[warehouseId].value.key = val;
    this.setForm({ ...this.form });
  }

  onMappingKeyChange(idx, val, warehouseId) {
    this.handleMappingChange({ idx, val, warehouseId, keyName: 'key' });
  }
  onMappingValueChange(idx, val, warehouseId) {
    this.handleMappingChange({ idx, val, warehouseId, keyName: 'value' });
  }

  onAddKeyValueRowClick(e, warehouseId) {
    e.preventDefault();
    this.form.mapping[warehouseId].value.mappings.push({ ...emptyMappingObject });
    this.setForm({ ...this.form });
  }

  onRemove(e, idx, warehouseId) {
    e.preventDefault();
    this.form.mapping[warehouseId].value.mappings.splice(idx, 1);
    this.setForm({ ...this.form });
  }

  getValueOfCustomDivisionCodeMapping(warehouseId) {
    if (!this.form.mapping[warehouseId]?.value) {
      this.form.mapping[warehouseId].value = defaultValueForCustomAccountIdMapping;
      this.setForm({ ...this.form });
    }

    return this.form.mapping[warehouseId].value;
  }

  handleMappingChange({ idx, val, keyName, warehouseId }) {
    try {
      this.form.mapping[warehouseId].value.mappings[idx][keyName] = val;
      this.setForm({ ...this.form });
    } catch (error) {
      console.error('error updating mapping value');
    }
  }
}

const emptyMappingObject = { key: '', value: '' };
export const defaultValueForCustomAccountIdMapping = {
  mappings: [emptyMappingObject],
};
export const defaultValueForDirectDivisionCode = { enabled: true };
